import React from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import { GetFiles } from "./action";
import { RemoteGrid } from "../../Grid";

import { Order, FileBrowserFilters } from "../../../constant";

class FirmwareModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isInitializing: false,
      isLoading: false,
      filter: {
        //pagination
        pagination: { currentPage: 1, pageSize: 10 },
        orderBy: Order.asc,
        search: "",

        searchBy: 0,
        operation: 0,
        unitFamily: props.unitFamily,
      },
    };
  }

  async componentDidUpdate(prevProps) {
    //only fire query when modal is shown
    if (!prevProps.show && prevProps.show !== this.props.show) {
      await this.setState({
        filter: {
          ...this.state.filter,
          pagination: { currentPage: 1, pageSize: 10 },
          orderBy: Order.asc,
          search: "",

          searchBy: 0,
          operation: 0,
        },
      });

      this.refreshFileList();
    }
  }

  refreshFileList = async () => {
    this.setState({ isLoading: true });
    await this.props.GetFiles(this.state.filter);
    this.setState({ isLoading: false });
  };

  onHandleSearch = async (searchCriteria) => {
    await this.setState({
      filter: {
        ...this.state.filter,
        search: searchCriteria.searchText,
        searchBy: searchCriteria.searchBy,
        operation: searchCriteria.operation,
        pagination: {
          ...this.state.filter.pagination,
          currentPage: 1,
        },
      },
    });

    this.refreshFileList();
  };

  onHandleTableChange = async (type, state) => {
    if (type === "sort") {
      await this.setState({
        filter: {
          ...this.state.filter,
          orderBy: state.sortOrder === "desc" ? Order.desc : Order.asc,
        },
      });
    } else {
      await this.setState({
        filter: {
          ...this.state.filter,
          pagination: {
            ...this.state.filter.pagination,
            currentPage: state.page,
            pageSize: state.sizePerPage,
          },
        },
      });
    }

    this.refreshFileList();
  };

  render() {
    const columns = [
      {
        dataField: "id",
        text: "Id",
        hidden: true,
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "fileName",
        text: "File Name",
        sort: true,
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "unitFamilies",
        text: "Family",
        sort: true,
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
        formatter: (cell, row) => {
          const selectedFamily = row.unitFamilies.find(
            (family) => family.unitFamilyId === this.state.filter.unitFamily
          );
          if (selectedFamily) {
            return selectedFamily.unitFamilyName;
          }
          return "";
        },
      },
      {
        dataField: "fileTypeKey",
        text: "File Type Key",
        hidden: true,
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "newSWSAPNumber",
        text: "SW SAP Number and Version",
        sort: true,
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "fileTypeValue",
        text: "Type",
        sort: true,
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "hasSecurityPatch",
        text: "Contains Security Update",
        sort: true,
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        formatter: (cell) => (cell === true ? "Yes" : "No"),
      },
    ];

    const rowStyle = { cursor: "pointer" };

    const rowEvents = {
      onClick: (e, row, rowIndex) => {
        this.props.onRowClick(row);
      },
    };

    return (
      <Modal
        dialogClassName="modal-xl"
        show={this.props.show}
        onHide={this.props.onHide}
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>Select Firmware</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RemoteGrid
            filterFields={FileBrowserFilters}
            data={this.props.files}
            columns={columns}
            loading={this.state.isLoading}
            pagination={this.state.filter.pagination}
            onSearch={this.onHandleSearch}
            onTableChange={this.onHandleTableChange}
            rowStyle={rowStyle}
            rowEvents={rowEvents}
          />
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-grey" onClick={this.props.onHide}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    files: state.configuration.files,
  };
};

const mapDispatchToProps = {
  GetFiles,
};

export default connect(mapStateToProps, mapDispatchToProps)(FirmwareModal);
